import { createColumnHelper } from '@tanstack/react-table';

import type { CarrierDTO, CarrierServiceDTO } from '@invenco/shipping-interface';

import { Card, CardHeader } from '@/components/core/card';
import {
  DataTable,
  DataTableCardBody,
  DataTableCardTitle,
  useDataTable,
  useDataTableState,
  useRowNavigationCallback,
} from '@/components/data-table';
import { carrierServiceCategoryTitle } from '@/shared/title-maps';

type Props = {
  carrier?: CarrierDTO;
  isLoading?: boolean;
};

const columnHelper = createColumnHelper<CarrierServiceDTO>();

const columns = [
  columnHelper.accessor('name', {
    header: 'Name',
  }),
  columnHelper.accessor('code', {
    header: 'Code',
  }),
  columnHelper.accessor('category', {
    header: 'Category',
    cell: ({ getValue }) => carrierServiceCategoryTitle[getValue()],
  }),
  columnHelper.accessor('externalCodes', {
    header: 'External codes',
    cell: ({ getValue }) => [...getValue()].sort().join(', '),
  }),
];

export function CarrierServicesTable({ carrier, isLoading }: Props) {
  const onClickRow = useRowNavigationCallback<CarrierServiceDTO>('/shipping/carrier-services');

  const { state, onSortingChange } = useDataTableState({
    columns,
    tableId: 'carrier-details-services',
  });

  const table = useDataTable({
    data: carrier?.carrierServices ?? [],
    columns,
    state,
    isLoading,
    manualPagination: true,
    onSortingChange,
  });

  return (
    <Card aria-label="Services">
      <CardHeader>
        <DataTableCardTitle table={table}>Services</DataTableCardTitle>
      </CardHeader>
      <DataTableCardBody table={table}>
        <DataTable table={table} onClickRow={onClickRow} />
      </DataTableCardBody>
    </Card>
  );
}
